<template>
  <div
    class="hmi-button"
    :style="{
      background: color,
      width: typeof width === 'number' ? width + 'px' : width,
      height: typeof height === 'number' ? height + 'px' : height,
      border: border,
    }"
  >
    <v-icon class="icon" v-if="icon" :style="{ color: fontColor }">{{
      icon
    }}</v-icon>
    <v-label class="label" :style="{ color: fontColor }">{{ label }}</v-label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "DarkGray",
    },
    height: {
      type: [Number, String],
      default: "auto",
    },
    width: {
      type: [Number, String],
      default: "auto",
    },
    border: {
      type: String,
      default: "2px solid #000",
    },
    size: {
      type: Number,
      default: 20,
    },
    icon: {
      type: String,
      default: "",
    },
    fontColor: {
      type: String,
      default: "black",
    },
  },
};
</script>

<style scoped>
.hmi-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s ease;
}

.hmi-button:hover {
  transform: scale(1.025);
}

.label {
  text-align: center;
  cursor: pointer;
  font-family: "Courier New", Courier, monospace !important;
  font-size: clamp(10px, 2.3vw, 21px) !important;
}
</style>
